import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import successImage from 'assets/svg/success-sparkles.svg?url';
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import Spin from 'components/Spin';
import Form from 'components/form';
import { BRAND, STAGE } from 'constants/config';
import { TIC } from 'constants/products';
import useRequest from 'hooks/useRequest';
import React, { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { addProduct, getStripePaymentMethods } from 'services/account.service';
import * as Actions from 'store/modules/settings/actions';
import toast from 'utils/toast';

const BuyNumberModal = ({ onClose, onSuccess }) => {
  const [t] = useTranslation('talk');
  const [submitted, setSubmitted] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const account = useSelector((s) => s.settings.account);
  const [paymentMethods, { loading, error }] = useRequest(
    getStripePaymentMethods,
  );

  const dispatch = useDispatch();
  const onSubmit = () => {
    const productId =
      BRAND === 'TIC' ? TIC['number_bundle'][STAGE] : 'number_bundle';
    return addProduct(productId).then(
      () => {
        setSubmitted(true);
        dispatch(Actions.loadAccount(account.account_id));
      },
      (err) => {
        toast.error(err.message);
      },
    );
  };

  if (submitted) {
    return (
      <Modal open maxWidth="xs" onClose={onClose}>
        <Box p={3} textAlign="center">
          <img src={successImage} style={{ height: 200 }} />
          <Typography sx={{ mt: 5, mb: 3 }} fontWeight={600} variant="h4">
            {t('congratulations', 'Congratulations!')}
          </Typography>
          <Typography paragraph>
            {t('payment-received', 'Your payment has been received.')}
            <br />
            {t(
              'credited-additional-number',
              'Your account was credited with 1 new number.',
            )}
          </Typography>
          <Button variant="outlined" onClick={onSuccess}>
            {t('get-started', 'Get Started!')}
          </Button>
        </Box>
      </Modal>
    );
  }

  if (!showForm && !submitted) {
    return (
      <Modal open maxWidth="xs" onClose={onClose}>
        <Box p={3} textAlign="center">
          <img src={successImage} style={{ height: 200 }} />
          <Typography sx={{ mt: 5, mb: 3 }} fontWeight={600} variant="h4">
            {t('need-numbers', 'Need more numbers?')}
          </Typography>
          <Typography paragraph>
            {t(
              'purchase-additional-number',
              'Purchase additional numbers for $4/mo',
            )}
          </Typography>
          <Button variant="outlined" onClick={() => setShowForm(true)}>
            {t('buy-now', 'Buy Now')}
          </Button>
        </Box>
      </Modal>
    );
  }

  const method = paymentMethods?.find((m) => m.is_default);

  return (
    <Modal
      open
      maxWidth="sm"
      fullWidth
      onClose={onClose}
      title={t('add-new-bundle', 'Add new numbers bundle')}
      actions={
        method ? (
          <Button color="primary" onClick={onSubmit}>
            {t('buy-now', 'Buy Now')}
          </Button>
        ) : null
      }
    >
      <Form>
        <Spin spinning={loading}>
          {paymentMethods && (
            <>
              {!method ? (
                <Alert variant="outlined" color="error">
                  {t(
                    'payment-method-error-msg',
                    'No Payment Method Found. You likely forgot to Add a payment method, please Add a Payment Method and try again to buy numbers Again',
                  )}
                </Alert>
              ) : (
                <>
                  <Alert variant="outlined" color="info">
                    {t(
                      'purchase-additional-number',
                      'Purchase aditional numbers for $4/mo',
                    )}
                  </Alert>
                  <Box mt={2}>
                    <Typography
                      gutterBottom
                      fontWeight={500}
                      variant="subtitle1"
                    >
                      {t('payment-details', 'Payment Details')}
                    </Typography>
                    <Typography color="text.secondary">
                      {method.card
                        ? `Pay with ${method.card.brand} ending with ${method.card.last4}`
                        : `Pay with ${method.us_bank_account.bank_name} ending with ${method.us_bank_account.last4}`}
                    </Typography>
                  </Box>
                </>
              )}
            </>
          )}
        </Spin>
      </Form>
    </Modal>
  );
};

export default BuyNumberModal;
